import React from 'react'

function T3simmobile(){
    return <div>T3simmobile</div>
}

export default T3simmobile